import { useLocale, useTranslations } from "next-intl";
import type { AppLocale } from "@lms/backend/lib/i18n/locale";
import { CSRF_HEADER } from "@lms/backend/lib/csrf-constants";
import { httpClient } from "@/services/http/client";

const LOCALE_STORAGE_KEY = "lms_locale";

export function LocaleSwitcher() {
  const locale = useLocale() as AppLocale;
  const t = useTranslations("nav");

  async function handleChange(nextLocale: AppLocale) {
    if (nextLocale === locale) return;

    localStorage.setItem(LOCALE_STORAGE_KEY, nextLocale);

    const csrfRes = await httpClient.get<{ data: { token: string } }>("/v1/csrf");
    const csrfToken = csrfRes.data.data.token;

    await httpClient.post(
      "/v1/locale",
      { locale: nextLocale },
      {
        headers: {
          [CSRF_HEADER]: csrfToken,
        },
      },
    );

    window.location.reload();
  }

  return (
    <select
      data-testid="locale-switcher"
      aria-label={t("language")}
      className="rounded-md border border-[var(--border-strong)] bg-transparent px-2 py-1 text-xs"
      value={locale}
      onChange={(e) => void handleChange(e.target.value as AppLocale)}
    >
      <option value="en">{t("english")}</option>
      <option value="hi">{t("hindi")}</option>
    </select>
  );
}
